import * as util from './util';
import CONST from './const';
import Deferred from './lib/Deferred';
import logger from './logger';
import workerScript from './worker';

const MAX_WORKER = 1;
const LOAD_TIMEOUT = 3000;

let workerDeferList = [];

export const support = (function() {
  let support;
  const noWorker = location.href.indexOf('__uploadNoWorker=1') !== -1;

  return () => {
    if (noWorker) {
      return false;
    }

    if (support !== undefined && support !== null) {
      return support;
    }

    support = window.Worker && window.Blob;

    return support;
  };
})();

const loadWorker = () => {
  const startTime = Date.now();
  const defer = new Deferred();

  const URL = window.URL || window.webkitURL;
  const blob = new Blob([workerScript], { type: 'application/javascript' });
  let worker;

  try {
    worker = new Worker(URL.createObjectURL(blob));
  } catch (err) {
    defer.reject({ ret: CONST.REPORT.WEBWORKER_TIMEOUT, msg: 'timeout' });
    return defer;
  }

  setTimeout(() => {
    defer.reject({ ret: CONST.REPORT.WEBWORKER_TIMEOUT, msg: 'timeout' });
  }, LOAD_TIMEOUT);

  worker.onmessage = function(e) {
    const data = e.data || {};

    if (data.cmd === 'loaded') {
      // 统计 worker 加载耗时
      util.report007('ENCRYPT_WORKER_LOADED', 0, 0, data.costTime);

      defer.resolve({ ret: 0, msg: '', worker: worker });
    }
  };

  worker.postMessage({
    cmd: 'loaded',
    time: startTime,
  });

  return defer;
};

const create = () => {
  let defer;

  if (support()) {
    defer = workerDeferList.shift();
    workerDeferList.push(loadWorker());
  } else {
    defer = new Deferred();
    defer.reject({
      ret: CONST.REPORT.NOT_SUPPORT_WEBWORKER,
      msg: 'not support worker',
    });
  }

  return defer;
};

export const work = (file, type) => {
  let defer = new Deferred();

  create()
    .done((result = {}) => {
      const taskId = Date.now() + Math.floor(Math.random() * 10000);
      const worker = result.worker;
      console.log('------', file);

      logger.log('[encrypt] cal hash by webworker, file size ' + file.size);

      worker.onmessage = e => {
        const data = e.data || {};

        if (data.cmd === 'init') {
          util.report007('ENCRYPT_WORKER_INIT', 0, 0, data.costTime);

          return;
        } else if (data.cmd === 'error') {
          defer.reject(data.error);
        } else {
          util.report007('ENCRYPT_WORKER_MESSAGE', 0, 0, data.costTime);

          defer.resolve(data.hash);
        }

        worker.terminate();
      };

      try {
        worker.postMessage({
          cmd: 'init',
          taskId: taskId,
          file: file,
          type: type,
          time: Date.now(),
        });
      } catch (error) {
        defer.reject({
          ret: CONST.REPORT.POST_FILE_MESSAGE_ERROR,
          msg: 'post file meesage error',
        });

        worker.terminate();
      }
    })
    .fail((result = {}) => {
      defer.reject(result);
    });

  return defer;
};

if (support()) {
  for (let i = 0; i < MAX_WORKER; i++) {
    workerDeferList.push(loadWorker());
  }
}
